interface InputProps {
  label: string;
  name: string;
  value: string | number;
  required?: boolean;
  id?: string;
  type?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  clasName?: string;
  disabled?: boolean;
  min?: string;
  max?: string;
  defaultValue?: string;
  suffix?: string;
}

export function Input({
  label,
  name,
  value,
  required,
  type = "text",
  onChange,
  clasName,
  id,
  disabled,
  min,
  max,
  defaultValue,
  suffix,
}: InputProps) {
  return (
    <div className={`flex flex-col text-grey ${clasName}`}>
      <label className="3xl:text-md text-sm font-thin">{label}{label === "" ? "" : ":"}</label>
      <div className="relative">
        <input
          type={type}
          name={name}
          id={id}
          required={required}
          disabled={disabled}
          value={(() => {
            if (type === "number") {
              const valueStr = value?.toString() || "";
              // Préserver les valeurs qui se terminent par un point ou une virgule
              // (pour permettre la saisie en cours comme "2." ou "2,")
              if (valueStr.endsWith('.') || valueStr.endsWith(',')) {
                return valueStr;
              }
              const numValue = parseFloat(valueStr);
              return isNaN(numValue) ? "" : numValue;
            }
            return value || "";
          })()}
          onChange={onChange}
          step="any"
          min={min}
          max={max}
          defaultValue={defaultValue}
          className={`shadow-lg border-light-blue border-2 rounded-md 3xl:p-2 p-1 mt-1 w-full ${disabled ? "bg-gray-100" : "bg-white"} ${suffix ? "pr-8" : ""}`}
        />
        {suffix && (
          <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-grey pointer-events-none mt-1">
            {suffix}
          </span>
        )}
      </div>
    </div>
  );
}
